import { z } from "zod";
import { sqlNumberSchema } from "./common.js";
/**
 * Row cap the bucketed fee-history and fee-spread reads apply to a window.
 *
 * Shared rather than server-private because the client has to size its buckets against it. A cap hit
 * doesn't read as truncation on the chart: the fees page draws its base-fee line from /fees/history
 * and every other series on the same chart from /fees/spread, so a response that ends early shows up
 * as one line stopping partway across a window the rest of the chart still spans.
 */
export const FEE_BUCKETED_POINT_LIMIT = 2000;
/**
 * Widest bucket the bucketed reads honour. A request for more is clamped to this, so a client that
 * asks past it gets finer buckets than it asked for — and finer buckets than the grid it merges
 * against, which is the same interrupted line by another route. Shared so that agreement is checkable.
 */
export const FEE_MAX_BUCKET_SIZE = 10_000;
export const feePricingSnapshotSchema = z.object({
    ethUsdPrice: z.number(),
    ethPerFeeAssetE12: z.string(),
    snapshotAgeSeconds: z.number(),
});
export const feeHistoryPointSchema = z.object({
    blockNumber: sqlNumberSchema,
    timestamp: sqlNumberSchema.nullable(),
    feePerDaGas: z.string().nullable(),
    feePerL2Gas: z.string().nullable(),
    totalFees: z.string().nullable(),
    numTxs: sqlNumberSchema,
    pricing: feePricingSnapshotSchema.nullable().optional(),
});
export const feeHistoryResponseSchema = z.object({
    data: z.array(feeHistoryPointSchema),
    bucketSize: z.number().optional(),
});
export const feeHistoryQuerySchema = z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    resolution: z.string().optional(),
});
export const feeSpreadBucketSchema = z.object({
    bucket: sqlNumberSchema,
    txCount: sqlNumberSchema,
    avgActualFee: z.string().nullable(),
    minActualFee: z.string().nullable(),
    maxActualFee: z.string().nullable(),
    p25ActualFee: z.string().nullable(),
    medianActualFee: z.string().nullable(),
    p75ActualFee: z.string().nullable(),
    medianMaxFeePerDaGas: z.string().nullable(),
    medianMaxFeePerL2Gas: z.string().nullable(),
    p25MaxFeePerL2Gas: z.string().nullable(),
    p75MaxFeePerL2Gas: z.string().nullable(),
    medianGasLimitDa: z.string().nullable(),
    medianGasLimitL2: z.string().nullable(),
    avgTimestamp: sqlNumberSchema.nullable().optional(),
    pricing: feePricingSnapshotSchema.nullable().optional(),
});
export const feeSpreadResponseSchema = z.object({
    data: z.array(feeSpreadBucketSchema),
    bucketSize: z.number(),
});
export const feeSpreadQuerySchema = z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    bucketSize: z.string().optional(),
});
export const currentFeesResponseSchema = z.object({
    block: feeHistoryPointSchema.nullable(),
    pricing: z
        .object({
        ethUsdPrice: z.number(),
        ethPerFeeAssetE12: z.string(),
    })
        .nullable(),
});
//# sourceMappingURL=fees.js.map